import { axiosPrivate } from "../../api/axios";
import { useEffect } from "react";
import handleError from "../../hooks/handleError";


// Save Invoices ("Save Changes")
const saveInvoices = (invoices) => {

    let isMounted = true;
    const controller = new AbortController();

    const invoicesToInsert = invoices.filter((row) => row.actions === "INSERT");
    const invoicesToUpdate = invoices.filter((row) => row.actions === "UPDATE");
    const invoicesToDelete = invoices.filter((row) => row.actions === "DELETE");

    const insertMoneyAccounts = async (invoicesToInsert) => {
        try {
            await axiosPrivate.post("/invoices",
                invoicesToInsert,
                { signal: controller.signal }
            );
        } catch (err) {
            handleError(err);
        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }

    const updateMoneyAccounts = async (invoicesToUpdate) => {
        try {
            await axiosPrivate.post("/invoices",
                invoicesToUpdate,
                { signal: controller.signal }
            );
        } catch (err) {
            handleError(err);
        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }

    const deleteMoneyAccounts = async (invoicesToDelete) => {
        try {
            await axiosPrivate.post("/invoices",
                invoicesToDelete,
                { signal: controller.signal }
            );
        } catch (err) {
            handleError(err);
        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }

    if (invoicesToDelete.length > 0) { deleteMoneyAccounts(invoicesToDelete) };
    if (invoicesToInsert.length > 0) { insertMoneyAccounts(invoicesToInsert) };
    if (invoicesToUpdate.length > 0) { updateMoneyAccounts(invoicesToUpdate) };

};
export default saveInvoices